import { cacheDom } from '../utils/QuerySelectors.js'
import { getXgenProducts } from '../utils/Product.js'

const dom = {}
const qs = {
  swiper: 'data-media-swiper',
}
const qsAll = {
  sections: 'data-section-type="related-products"',
}

const iObserver = new IntersectionObserver((items) => {
  const target = items[0].target
  if (items[0].isIntersecting && !target.querySelector(`[${qs.swiper}]`).classList.contains('swiper-initialized'))
    initSection(target)
})

const initSlider = (section, isXgen = false) => {
  const json = JSON.parse(section.querySelector('[type="application/json"]').innerHTML)
  const swiperElement = section.querySelector(`[${qs.swiper}]`)
  const scriptElement = section.querySelector('[data-script] script')
  if (scriptElement && !isXgen) {
    swiperElement.querySelector('.swiper-wrapper').innerHTML = scriptElement.innerHTML
    window.setupApiTiles(swiperElement)
  }

  let options = {
    slidesPerView: 1.5,
    spaceBetween: 12,
    grabCursor: true,
    a11y: {
      enabled: true,
    },
    breakpoints: {
      320: {
        slidesPerView: json.mobile + 0.5,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: json.tablet + 0.5,
      },
      1024: {
        slidesPerView: json.desktop + 0.5,
        spaceBetween: 16,
      },
      1440: {
        slidesPerView: json.large + 0.5,
        spaceBetween: 16,
      },
    },
    on: {
      init: function () {
        // section.classList.add('!opacity-100')
        setTimeout(() => {
          _swat.initializeActionButtons('.related-products', '[data-swaction]')
        }, 500)
      },
    },
  }
  if (swiperElement.getAttribute('data-auto-rotate') == 'true') {
    options = Object.assign(options, {
      freeMode: true,
      loop: true,
      speed: 7000,
      autoplay: {
        delay: 0.5,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
    })
  } else {
    options = Object.assign(options, {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }
  const sectionSwiper = new Swiper(swiperElement, options)
  if (swiperElement.getAttribute('data-auto-rotate') == 'true') {
    swiperElement.addEventListener('mouseenter', () => {
      sectionSwiper.autoplay.stop()
      _swat.initializeActionButtons('.related-products', '[data-swaction]')
    })
    swiperElement.addEventListener('mouseleave', () => {
      sectionSwiper.autoplay.start()
      _swat.initializeActionButtons('.related-products', '[data-swaction]')
    })
  }
}

const initSection = (section) => {
  const swiperElement = section.querySelector(`[${qs.swiper}]`)
  const xgenId = swiperElement.dataset.xgen
  const excludeSale = swiperElement.dataset.excludeSale

  if (xgenId) {
    if (typeof getXgenPredictions != 'undefined') {
      getXgenPredictions(xgenId).then((results) => {
        const skus = results.map((result) => result.variants[0].sku).filter(Boolean)
        const sectionId = section.dataset.sectionId
        if (skus.length > 0) {
          getXgenProducts((results) => {
            console.log('related products', results)
            const swiperWrapper = section.querySelector('.swiper-wrapper')
            const filteredResults =
              excludeSale == 'true'
                ? results.filter((result) => !result.tags.includes('Sale') && !result.tags.includes('Final Sale'))
                : results
            filteredResults.forEach((result) => {
              result.related = true
              swiperWrapper.innerHTML += `
                <div class="swiper-slide">
                  <div class="h-full" product-tile props='${JSON.stringify(result).replaceAll("'", '’')}' section_id='${sectionId}'></div>
                </div>
              `
            })
            window.setupProductTiles(swiperWrapper.querySelectorAll('[product-tile]:empty'))
            initSlider(section, true)
          }, skus)
        } else {
          swiperElement?.closest('[data-section-type="related-products"]')?.classList.add('!hidden')
        }
      })
    }
  } else initSlider(section)
}

export const setupRelatedProducts = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => iObserver.observe(section))
}
